import React, { useState } from 'react';
import { ConfigProvider, Card, Tabs, theme } from 'antd';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DashboardStats from './components/DashboardStats';
import PatientTable from './components/PatientTable';
import AppointmentCard from './components/AppointmentCard';
import MedicalRecords from './components/MedicalRecords';
import BillingModule from './components/BillingModule';
import AddPatientPage from './components/AddPatientPage';
import DentalChartingPage from './components/dental/DentalChart';
import { antThemeTokens, cssVariables } from './theme/healthcareTheme';

const { TabPane } = Tabs;
const { useToken } = theme;

// Inject CSS variables into the document
const injectCSSVariables = () => {
  const style = document.createElement('style');
  style.innerHTML = cssVariables;
  document.head.appendChild(style);
};

const App = () => {
  const [activeTab, setActiveTab] = useState('1');
  const { token } = useToken();

  // Inject CSS variables on component mount
  React.useEffect(() => {
    injectCSSVariables();
  }, []);

  // Common layout wrapper component to avoid code duplication
  const LayoutWrapper = ({ children, showTabs = true }) => (
    <div style={{ 
      padding: window.innerWidth < 768 ? '16px' : '24px', 
      background: token.colorBgLayout,
      minHeight: 'calc(100vh - 120px)',
    }}>
      <DashboardStats />
      {showTabs && (
        <Card 
          bordered={false} 
          style={{ 
            borderRadius: '12px',
            boxShadow: token.boxShadow,
            background: token.colorBgContainer,
            border: `1px solid ${token.colorBorder}`
          }}
        >
          <Tabs 
            activeKey={activeTab} 
            onChange={setActiveTab}
            tabBarStyle={{
              padding: '0 24px',
              margin: 0,
              background: token.colorBgContainer
            }}
          >
            <TabPane tab="Patients" key="1">
              <PatientTable />
            </TabPane>
            <TabPane tab="Appointments" key="2">
              <AppointmentCard />
            </TabPane>
            <TabPane tab="Medical Records" key="3">
              <MedicalRecords />
            </TabPane>
            <TabPane tab="Billing" key="4">
              <BillingModule />
            </TabPane>
          </Tabs>
        </Card>
      )}
      {children}
    </div>
  );

  return (
    <ConfigProvider theme={antThemeTokens}>
      <Router>
        <Routes>
          {/* Main Dashboard Route */}
          <Route path="/" element={
            <LayoutWrapper />
          } />
          
          {/* Patient Route - same as main dashboard */}
          <Route path="/patient" element={
            <LayoutWrapper />
          } />
          
          {/* Add Patient Route */}
          <Route path="/patient/add-patient" element={<AddPatientPage />} />
          
          {/* New Dental Charting Route */}
          <Route path="/dental-charting" element={
            <div style={{ 
              background: token.colorBgLayout,
              minHeight: '100vh',
            }}>
              <DentalChartingPage />
            </div>
          } />
          
          {/* Optional: Dental charting with patient context */}
          <Route path="/patient/:patientId/dental-charting" element={
            <div style={{ 
              background: token.colorBgLayout,
              minHeight: '100vh',
            }}>
              <DentalChartingPage />
            </div>
          } />
        </Routes>
      </Router>
    </ConfigProvider>
  );
};

export default App;